// 홈 상단 카드 — 서버 호출(2026-10-19). 규칙은 src/lib/homeCards.js · 서버 supabase/migrations/20261027100000_home_card.sql.
//   🔒 RPC 이름·인자 이름은 마이그레이션과 같아야 한다 — homeCardsApi.test.js 가 마이그레이션 원문과 대조한다.
import { supabase } from "./supabaseClient";
import { endOfKstDayIso, normalizeCardLink } from "./homeCards";

/** 지금 보일 카드. email = 화면이 보고 있는 계정(다른 회원으로 보기 중이면 그 회원 — 서버는 그때 읽기만 한다) */
export async function fetchMyHomeCards(email) {
  const { data, error } = await supabase.rpc("my_home_cards", { p_email: email || null });
  if (error) throw error;
  return data || [];
}

/** 「확인했습니다」(confirm — 다시 안 뜸) 또는 링크 누름(click) */
export async function ackHomeCard(cardId, action) {
  if (action !== "confirm" && action !== "click") throw new Error("action must be confirm|click");
  const { data, error } = await supabase.rpc("home_card_ack", { p_card_id: cardId, p_action: action });
  if (error) throw error;
  return data;
}

/** 받는 사람 미리 세기 — 공지와 같은 계산(어드민만). [{ user_email, reason }] */
export async function previewAudience(audience) {
  const { data, error } = await supabase.rpc("resolve_announcement_audience", { p_audience: audience });
  if (error) throw error;
  return data || [];
}

/** 보내기 */
export async function sendHomeCard({ audience, audienceLabel, title, body, link, ctaLabel, tone, endDate }) {
  const href = normalizeCardLink(link).href;
  const { data, error } = await supabase.rpc("admin_send_home_card", {
    p_audience: audience,
    p_title: title,
    p_body: body,
    p_link: href,
    p_cta_label: href ? (ctaLabel || null) : null,
    p_tone: tone || "brand",
    p_ends_at: endOfKstDayIso(endDate),
    p_audience_label: audienceLabel || null,
  });
  if (error) throw error;
  return data;
}

export async function fetchHomeCardList(limit = 50) {
  const { data, error } = await supabase.rpc("admin_home_card_list", { p_limit: limit });
  if (error) throw error;
  return data || [];
}

export async function fetchHomeCardRecipients(cardId) {
  const { data, error } = await supabase.rpc("admin_home_card_recipients", { p_card_id: cardId });
  if (error) throw error;
  return data || [];
}

export async function cancelHomeCard(cardId) {
  const { data, error } = await supabase.rpc("admin_cancel_home_card", { p_card_id: cardId });
  if (error) throw error;
  return data;
}

/** 작품 검색(어드민 · 2글자 이상) — 승인 참여자 대상으로 고를 작품 */
export async function searchWorks(q) {
  const v = String(q || "").trim();
  if (v.length < 2) return [];
  const { data, error } = await supabase
    .from("licensed_video")
    .select("id, title, company, video_type, total_episodes")
    .ilike("title", `%${v.replace(/[%_]/g, (c) => `\\${c}`)}%`)
    .order("title")
    .limit(20);
  if (error) throw error;
  return data || [];
}

/** 사용자 검색(어드민 · 이름·이메일) */
export async function searchUsers(q) {
  const v = String(q || "").trim().replace(/[,()]/g, " ");
  if (v.length < 1) return [];
  const { data, error } = await supabase
    .from("user")
    .select("email, name, role, company")
    .or(`name.ilike.%${v}%,email.ilike.%${v}%`)
    .limit(10);
  if (error) throw error;
  return data || [];
}
